(() => {
    'use strict';

    /* ------------------------------------------------------------------
     * Contact form.
     *
     * Two things a real page load used to do for this form, which a swup swap
     * does not, plus one that never worked in the English form at all.
     *
     * The send icon: Contact Form 7 renders the submit control as
     * <input type="submit">, which cannot hold a child, so the paper plane has to
     * be a sibling that something puts there. That used to be an inline <script>
     * in the block template, and it failed twice over — it matched the button by
     * its Dutch value ("VERSTUUR"), so on the English form the lookup returned
     * null and it threw before placing anything, and inline scripts inside markup
     * swup swaps in never execute, so arriving here by clicking a link got no icon
     * either. Matching on the class the form itself sets fixes the first, and
     * being a module transitions.js can re-init fixes the second.
     *
     * The form itself: Contact Form 7 binds its submit handler from its own
     * DOMContentLoaded, which a swap never fires. Left alone, the swapped-in form
     * keeps its "no-js" class and posts natively — the page reloads and the
     * message is lost. Re-arming the decoration while the thing it decorates stays
     * dead is worse than not decorating it, so both live here.
     * ---------------------------------------------------------------- */

    const ICON_CLASS = 'fa-paper-plane';

    // Contact Form 7 initialises itself once, from DOMContentLoaded. After a swup
    // swap the form in the page is a different element than the one it initialised.
    const ensureCf7 = () => {
        const cf7 = window.wpcf7;

        // On a hard load this runs before CF7's own handler has defined init(), which
        // is exactly right: leave the first initialisation to CF7.
        if (!cf7 || typeof cf7.init !== 'function') {
            return;
        }

        document.querySelectorAll('.wpcf7 > form').forEach((form) => {
            if (form.wpcf7) {
                return;
            }

            cf7.init(form);
            form.closest('.wpcf7').classList.replace('no-js', 'js');

            // init() drops this form's cached validation schema and only CF7's
            // DOMContentLoaded ever fetches it again. Without it wpcf7.validate()
            // returns early, so the per-field messages stay silent until a submit.
            const id = form.wpcf7 && form.wpcf7.id;

            if (!id || !cf7.api || !cf7.schemas || cf7.schemas.get(id)) {
                return;
            }

            const root = cf7.api.root.slice(-1) === '/' ? cf7.api.root : cf7.api.root + '/';
            const namespace = (cf7.api.namespace || 'contact-form-7/v1').replace(/^\/|\/$/g, '');

            window.fetch(root + namespace + '/contact-forms/' + id + '/feedback/schema', {
                headers: { Accept: 'application/json, */*;q=0.1' },
            })
                .then((response) => (response.ok ? response.json() : null))
                .then((schema) => {
                    if (schema) {
                        cf7.schemas.set(id, schema);
                    }
                })
                // Losing the schema costs live validation, not the form: the server
                // validates the submit anyway and CF7 renders what it sends back.
                .catch(() => {});
        });
    };

    const ensureIcon = () => {
        document.querySelectorAll('.Contactformulier .cf7-submit').forEach((submit) => {
            const row = submit.parentElement;

            // Idempotent: a hard load may still have an icon placed by an older copy
            // of the block template, and init() runs again after every swap.
            if (!row || row.querySelector('.' + ICON_CLASS)) {
                return;
            }

            const icon = document.createElement('i');
            icon.className = 'fa-solid ' + ICON_CLASS;
            icon.setAttribute('aria-hidden', 'true');

            row.appendChild(icon);
        });
    };

    // CF7 first: its init inserts the spinner directly after the submit button, so
    // running it first leaves the same input -> spinner -> plane order a hard load has.
    const init = () => {
        ensureCf7();
        ensureIcon();
    };

    window.MB = window.MB || {};
    window.MB.contactForm = { init };

    init();
})();
